module.exports = __webpack_public_path__ + "static/media/p16-boxoffice.19510ba2.csv";